const group = [
    {
        path: '/group',
        name: 'Group',
        component: () =>
            import('../views/index/group/Group.vue'),
        meta: {
            title: '嗨拼团',
        }
    },
    {
        path: '/my-group',
        name: 'MyGroup',
        component: () =>
            import('../views/index/group/MyGroup.vue'),
        meta: {
            title: '我的拼团',
        }
    },
    {
        path: '/group-rule',
        name: 'GroupRule',
        component: () =>
            import('../views/index/group/GroupRule.vue'),
        meta: {
            title: '拼团玩法',
        }
    },
    {
        path: '/group-detail',
        name: 'GroupDetail',
        component: () =>
            import('../views/index/group/GroupDetail.vue'),
        meta: {
            title: '拼团详情',
        }
    },
    {
        path: '/all-group',
        name: 'AllGroup',
        component: () =>
            import('../views/index/group/AllGroup.vue'),
        meta: {
            title: '团员概况',
        }
    },
]

export default group